import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";

import {
  generateDateField,
  generateInputField,
  generateSelectField,
} from "helpers/form_helper_new";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useEffect, useMemo } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
} from "reactstrap";
import {
  createSignMethod,
  editSignMethod,
} from "store/general-info/sign-method/actions";
import * as yup from "yup";
import { modeDetail } from "./utils";

const DetailData = props => {
  const { isOpenModal, dataDetail, toggleModal, mode, listVat } = props;
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation(["signMethod"]);
  const { addToast } = useToasts();

  const Dashboard = useSelector(state => state.Dashboard);
  const { buTenantHeaderInfo, finalBuInfo } = Dashboard;

  const optionBU = useMemo(() => {
    const listOption = [];
    if (buTenantHeaderInfo) {
      listOption.push({
        value: buTenantHeaderInfo.code,
        label: buTenantHeaderInfo.label,
      });
    }
    if (finalBuInfo) {
      listOption.push({
        value: finalBuInfo.code,
        label: finalBuInfo.label,
      });
    }
    return listOption;
  }, [buTenantHeaderInfo, finalBuInfo]);

  const optionInvoiceType = [
    {
      value: "0",
      label: "HĐ Không Mã",
    },
    {
      value: "1",
      label: "HĐ Có Mã",
    },
  ];

  const signMethod = useSelector(state => state.signMethod);
  const { loading, data, error } = signMethod.detailSignMethod;
  const { loading: loadingCreate } = signMethod.createSignMethod;

  const schema = yup.object().shape({
    business_unit_code: yup
      .object()
      .required(
        t("form.validate.required", { title: t("form.business_unit_code") })
      )
      .nullable(),
    company_name: yup
      .string()
      .required(t("form.validate.required", { title: t("form.company_name") })),
    invoice_type: yup
      .object()
      .required(t("form.validate.required", { title: t("form.invoice_type") }))
      .nullable(),
    ca_id: yup.string(),
    // .required(t("form.validate.required", { title: t("form.company_name") })),
    ca_password: yup.string(),
    // .required(t("form.validate.required", { title: t("form.company_name") })),
    serial_num: yup
      .string()
      .required(t("form.validate.required", { title: t("form.serial_num") })),
    valid_time: yup.array().min(2, "Vui lòng chọn khoảng thời gian hiệu lực"),
    is_default: yup.bool(),
  });

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
  } = useForm({
    resolver: yupResolver(schema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      business_unit_code: null,
      company_name: "",
      invoice_type: null,
      ca_id: "",
      ca_password: "",
      serial_num: "",
      valid_time: [],
      is_default: true,
    },
  });

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ errors:", errors);
  }, [errors]);

  useEffect(() => {
    if (isOpenModal) {
      reset();
      if (dataDetail) {
        setValue(
          "business_unit_code",
          optionBU.find(o => o.value === dataDetail.business_unit_code) || null
        );
        setValue("company_name", dataDetail.company_name);
        setValue(
          "invoice_type",
          optionInvoiceType.find(
            o => Number(o.value) === Number(dataDetail.invoice_type)
          )
        );
        setValue("serial_num", dataDetail.serial_num);
        setValue("valid_time", [
          new Date(dataDetail.issued_time),
          new Date(dataDetail.expired_time),
        ]);
        setValue("is_default", dataDetail.is_default === "1" ? true : false);
      }
    }
  }, [isOpenModal]);

  const onSubmit = values => {
    const {
      invoice_type,
      business_unit_code,
      valid_time,
      is_default,
      ca_password,
      ca_id,
    } = values;
    let data = {
      ...values,
      valid_time: undefined,
      ca_password: ca_password || undefined,
      ca_id: ca_id || undefined,
      is_default: is_default ? "1" : "0",
      invoice_type: invoice_type?.value,
      business_unit_code: business_unit_code?.value,
      issued_time: moment(valid_time?.[0])
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
      expired_time: moment(valid_time?.[1])
        .endOf("day")
        .format("YYYY-MM-DD HH:mm:ss"),
    };
    switch (mode) {
      case modeDetail.CREATE:
        dispatch(createSignMethod(data));
        break;
      case modeDetail.EDIT:
        dispatch(editSignMethod(data, dataDetail.id));
        break;
      default:
        break;
    }
  };

  return (
    <React.Fragment>
      <Modal
        size="xl"
        isOpen={isOpenModal}
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        toggle={toggleModal}
      >
        <div className="modal-content">
          <ModalHeader toggle={toggleModal}>
            {mode === modeDetail.CREATE && `Thêm Sign Method`}
            {mode === modeDetail.VIEW && `Chi tiết Sign Method`}
            {mode === modeDetail.EDIT && `Cập nhật Sign Method`}
          </ModalHeader>
          {loading ? (
            <ModalBody>
              <LoadingFormNormal
                countInput="3"
                countButton="1"
                formClass="row-cols-1 row-cols-md-2"
                buttonClass="justify-content-end"
                buttonColClass="col-3"
              />
            </ModalBody>
          ) : (
            <React.Fragment>
              <ModalBody>
                <Row className="row-cols-1 row-cols-lg-2">
                  <Col>
                    <FormGroup className="mb-3">
                      {generateSelectField({
                        label: t("form.business_unit_code"),
                        isRequire: true,
                        errors: errors,
                        fieldKey: "business_unit_code",
                        placeholder: t("placeholder.select", {
                          title: t("form.business_unit_code"),
                        }),
                        disabled: mode === modeDetail.VIEW || loading,
                        control: control,
                        options: optionBU,
                        menuPlacementSetting: "auto",
                        onChangeHandle: () => {},
                        isClassCustomForm: false,
                        // isLoading: false,
                        // allowCreate: item.allowCreate,
                        // widthLabel: item.widthLabel,
                        // extraComponent: extraComponent,
                        // isClearable: item.isClearable,
                      })}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField({
                        label: t("form.company_name"),
                        isRequire: true,
                        inputType: "text",
                        errors: errors,
                        touched: touchedFields,
                        fieldName: "company_name",
                        placeholder: t("placeholder.enter", {
                          title: t("form.company_name"),
                        }),
                        register: register,
                        disabled: mode === modeDetail.VIEW || loading,
                        control: control,
                        // isThousandSeparator: item.isThousandSeparator,
                        isShowLabel: true,
                        isClassCustomForm: false,
                      })}
                    </FormGroup>
                  </Col>
                  <Col>
                    <FormGroup className="mb-3">
                      {generateSelectField({
                        label: t("form.invoice_type"),
                        isRequire: true,
                        errors: errors,
                        fieldKey: "invoice_type",
                        placeholder: t("placeholder.select", {
                          title: t("form.invoice_type"),
                        }),
                        disabled: mode === modeDetail.VIEW || loading,
                        control: control,
                        options: optionInvoiceType,
                        menuPlacementSetting: "auto",
                        onChangeHandle: () => {},
                        isClassCustomForm: false,
                        // isLoading: false,
                        // allowCreate: item.allowCreate,
                        // widthLabel: item.widthLabel,
                        // extraComponent: extraComponent,
                        // isClearable: item.isClearable,
                      })}
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField({
                        label: t("form.serial_num"),
                        isRequire: true,
                        inputType: "text",
                        errors: errors,
                        touched: touchedFields,
                        fieldName: "serial_num",
                        placeholder: t("placeholder.enter", {
                          title: t("form.serial_num"),
                        }),
                        register: register,
                        disabled: mode === modeDetail.VIEW || loading,
                        control: control,
                        // isThousandSeparator: item.isThousandSeparator,
                        isShowLabel: true,
                        isClassCustomForm: false,
                      })}
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField({
                        label: t("form.ca_id"),
                        isRequire: false,
                        inputType: "text",
                        errors: errors,
                        touched: touchedFields,
                        fieldName: "ca_id",
                        placeholder: t("placeholder.enter", {
                          title: t("form.ca_id"),
                        }),
                        register: register,
                        disabled: mode === modeDetail.VIEW || loading,
                        control: control,
                        // isThousandSeparator: item.isThousandSeparator,
                        isShowLabel: true,
                        isClassCustomForm: false,
                      })}
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup className="mb-3">
                      {generateInputField({
                        label: t("form.ca_password"),
                        isRequire: false,
                        inputType: "text",
                        errors: errors,
                        touched: touchedFields,
                        fieldName: "ca_password",
                        placeholder: t("placeholder.enter", {
                          title: t("form.ca_password"),
                        }),
                        register: register,
                        disabled: mode === modeDetail.VIEW || loading,
                        control: control,
                        // isThousandSeparator: item.isThousandSeparator,
                        isShowLabel: true,
                        isClassCustomForm: false,
                      })}
                    </FormGroup>
                  </Col>

                  <Col>
                    <FormGroup className="mb-3">
                      {generateDateField({
                        labelFrom: t("form.valid_time"),
                        isRequire: true,
                        errors: errors,
                        field: "valid_time",
                        placeholder: "DD/MM/YYYY",
                        disabled: mode === modeDetail.VIEW || loading,
                        control: control,
                        isClassCustomForm: false,
                        options: {
                          mode: "range",
                        },
                      })}
                    </FormGroup>
                  </Col>
                  <Col className="mt-4">
                    <FormGroup>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          disabled={mode === modeDetail.VIEW || loading}
                          id="checkbox_is_default"
                          className="custom-control-input checkbox-is_default"
                          style={{
                            width: "20px",
                            height: "20px",
                            marginTop: 0,
                          }}
                          {...register("is_default")}
                        />
                        <label
                          style={{
                            marginLeft: "10px",
                            marginBottom: 0,
                          }}
                          htmlFor="checkbox_is_default"
                        >
                          Mặc định
                        </label>
                      </div>
                    </FormGroup>
                  </Col>
                </Row>
              </ModalBody>
              <ModalFooter>
                {mode !== modeDetail.VIEW && (
                  <Row className="justify-content-end">
                    <Col className="col-auto">
                      <Button
                        color="primary"
                        className="btn-label"
                        type="button"
                        onClick={() => {
                          handleSubmit(onSubmit)();
                        }}
                        disabled={loading}
                      >
                        <i className="bx bx-save label-icon"></i>
                        {mode === modeDetail.CREATE && t("form.save")}
                        {mode === modeDetail.EDIT && t("form.update")}
                      </Button>
                    </Col>
                  </Row>
                )}
              </ModalFooter>
            </React.Fragment>
          )}
        </div>
      </Modal>
    </React.Fragment>
  );
};

DetailData.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
  mode: PropTypes.string,
  listVat: PropTypes.array,
};

DetailData.defaultProps = {
  isOpenModal: false,
  dataDetail: {},
  mode: "",
};

export default DetailData;
